package com.r_estrategica.redacaoestrategica.data

// --- INTEROP JS ---
external val db: dynamic
external val AppState: dynamic

fun logDebug(message: String, data: Any? = null) {
    if (data != null) {
        kotlin.io.println("[DEBUG] $message " + data.toString())
    } else {
        kotlin.io.println("[DEBUG] $message")
    }
}

enum class EixoTematico {
    SOCIAL, AMBIENTAL, MEIO_AMBIENTE,
    TECNOLOGIA, EDUCACAO, CIENCIA, CULTURA, SAUDE, POLITICA, ECONOMIA, DIREITO, SEGURANCA, ESPORTE, CIDADANIA
}

enum class TipoAgente { GOVERNAMENTAL, NAO_GOVERNAMENTAL }

enum class EixoAgente(val nome: String) {
    GESTAO("Gestão e planejamento"), ECONOMIA("Economy"), SOCIAL("Social e cidadania"),
    JUSTICA("Justiça e segurança"), AMBIENTAL_CULTURAL("Ambiental e cultural"),
    SOCIEDADE_CIVIL("Sociedade civil / ONGs"), ENTIDADES_CLASSE("Conselhos e associações")
}

data class AgenteIntervencao(
    val nome: String,
    val sigla: String,
    val tipo: TipoAgente,
    val eixo: EixoAgente,
    val funcaoSocial: String,
    val exemploAcao: String,
    val imagemResId: Int? = null
)

object BancoDeAgentes {
    val listaAgentes = listOf(
        AgenteIntervencao(
            nome = "Casa Civil",
            sigla = "",
            tipo = TipoAgente.GOVERNAMENTAL,
            eixo = EixoAgente.GESTAO,
            funcaoSocial = "É o \"motor\" do governo. Coordena todos os ministérios, analisa a viabilidade e legalidade das propostas e gerencia programas estratégicos.",
            exemploAcao = "Analisar uma Medida Provisória sobre um novo programa social antes de ela ser enviada ao Congresso Nacional."
        ),
        AgenteIntervencao(
            nome = "Ministério da Educação",
            sigla = "MEC",
            tipo = TipoAgente.GOVERNAMENTAL,
            eixo = EixoAgente.SOCIAL,
            funcaoSocial = "Formula e coordena a política nacional de educação, da creche à universidade, incluindo ensino técnico e EJA.",
            exemploAcao = "Organizar e aplicar o Exame Nacional do Ensino Médio (ENEM) por meio do INEP."
        )
    )
}

data class Verbete(
    val palavraChave: String,
    val categoria: String,
    val sinonimos: List<String>
)

object BancoSinonimos {
    val listaOriginal = listOf(
        Verbete(
            palavraChave = "DESIGUALDADE",
            categoria = "Diferenças Sociais",
            sinonimos = listOf("disparidade", "assimetria social", "iniquidade", "diferenciação", "desproporção", "distanciamento socioeconômico")
        ),
        Verbete(
            palavraChave = "EDUCAÇÃO",
            categoria = "Ensino / Formação",
            sinonimos = listOf("instrução", "ensino", "processo formativo", "formação acadêmica", "letramento", "capacitação pedagógica")
        )
    )
}

// --- TRILHA DE APRENDIZAGEM (ESTRUTURA COMPLETA) ---

enum class TipoLicao {
    TEORIA, PRATICA_QUIZ, CHEFAO, TEORIA_INTERATIVA, CONSTRUCAO_DRAG_DROP, ANALISE_HOTSPOT, MULTIPLA_ESCOLHA, MATERIAL_PDF
}

enum class EstadoLicao { BLOQUEADA, DISPONIVEL, CONCLUIDA }

data class LicaoTrilha(
    val id: Int = 0,
    val secao: String = "",
    val titulo: String = "",
    val tipo: TipoLicao = TipoLicao.TEORIA,
    val estadoInicial: EstadoLicao = EstadoLicao.BLOQUEADA,
    val conteudo: dynamic = null, // dynamic para interop JS com objetos complexos do Firestore
    val conteudoTeorico: ConteudoTeorico? = null,
    val exercicios: List<QuestaoTrilha>? = null,
    val infograficoResId: Int? = null,
    val infograficoUrl: String? = null,
    val pdfUrl: String? = null,
    val youtubeVideoId: String? = null
)

data class ConteudoTeoriaInterativa(val telas: List<TelaInterativa>)
data class TelaInterativa(
    val subtitulo: String,
    val textoCurto: String,
    val perguntaDesbloqueio: String,
    val opcaoCorreta: String,
    val opcaoErrada: String,
    val feedbackErro: String
)

data class ConteudoDragAndDrop(
    val instrucao: String,
    val feedbackSucesso: String,
    val blocos: List<BlocoTexto>
)
data class BlocoTexto(
    val id: String,
    val texto: String,
    val ordemCorreta: Int
)

data class ConteudoAnaliseHotspot(
    val instrucaoTopico: String,
    val trechos: List<TrechoTexto>
)
data class TrechoTexto(
    val texto: String,
    val ehOAlvo: Boolean,
    val feedbackToque: String
)

data class ConteudoMultiplaEscolha(
    val pergunta: String,
    val opcoes: List<Opcao>
)

data class Opcao(
    val id: String,
    val texto: String,
    val isCorreta: Boolean,
    val feedback: String
)

data class ConteudoTeorico(val topicos: List<TopicoAula>)
data class TopicoAula(
    val subtitulo: String,
    val texto: String? = null,
    val exemplo: String? = null,
    val destaqueImportante: String? = null,
    val citacao: String? = null
)

data class QuestaoTrilha(
    val pergunta: String,
    val opcoes: List<String>,
    val indiceCorreto: Int,
    val explicacao: String
)
